module.exports = __webpack_public_path__ + "img/img8.6d2a8ab6.png";